import { DateTime } from 'luxon';
import { ZONE } from '../constants';
import { Site, SpecialTariffPricing } from '../../generated/graphql';
import { t } from 'i18next';

export const getSpecialTariffText = (
  selectedSite: Site | null,
  specialTariffsToRender: SpecialTariffPricing[],
  specialTariffSelected: number | null,
  specialTariffMessage: string | undefined
) => {
  if (selectedSite) {
    if (specialTariffsToRender.length === 0) {
      return <>{t('noSpecialRates')}</>;
    }
    const pricing = specialTariffsToRender.find(
      (x) => x.id === specialTariffSelected
    );
    if (specialTariffMessage) {
      return <>{specialTariffMessage}</>;
    }
    if (pricing) {
      if (pricing.untilTime) {
        return (
          <>
            {t('untilText', {
              untilTime: pricing.untilTime,
              tomorrowText:
                pricing.end < pricing.start || (pricing.untilTime && pricing.untilTime < pricing.start) ? t('tomorrowText') : '',
            })}
          </>
        );
      } else if (pricing.sessionTime) {
        const currentTimeInAuckland = DateTime.now().setZone(ZONE);
        const unit = pricing.sessionTimeUnit ?? 'hours'
        const limitTime = currentTimeInAuckland.plus({
          [unit.toLocaleLowerCase()]: pricing.sessionTime,
        });
        const timeToShow = limitTime.toFormat('t');
        return (
          <>
            {t('parkingSession', { sessionTime: pricing.sessionTime })}
            <br />
            {t('paidUntilText', { timeToShow })}
          </>
        );
      } else {
        return (
          <>
            From {pricing.start} until {pricing.end}
            {pricing.end < pricing.start || (pricing.untilTime && pricing.untilTime < pricing.start) ? ' tomorrow' : ''}`
          </>
        );
      }
    }
  }
  return <></>;
};
